(function initSuiQuizLogger(global) {
  const config = {
    endpoint: typeof global.__QUIZ_LOG_ENDPOINT__ === 'string' ? global.__QUIZ_LOG_ENDPOINT__ : null,
    apiKey: typeof global.__QUIZ_LOG_API_KEY__ === 'string' ? global.__QUIZ_LOG_API_KEY__ : null,
  };

  const noopLogger = {
    initSession() { },
    syncProgress() { },
    recordRecommended() { },
    markCompleted() { },
  };

  if (!config.endpoint) {
    global.SuiQuizLogger = noopLogger;
    if (global.console && typeof global.console.warn === 'function') {
      global.console.warn('[SuiQuizLogger] Log endpoint tanimli degil. Kayit devre disi.');
    }
    return;
  }

  const state = {
    sessionId: null,
    answers: {},
    history: [],
    recommended: [],
    aiResponse: null,
    flushTimer: null,
    pendingPayload: null,
    inFlight: false,
  };

  const clone = (value) => {
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (_err) {
      return value;
    }
  };

  const buildPayload = (extra) => {
    const answers = clone(state.answers) || {};
    const email =
      (answers && typeof answers.email === 'string' && answers.email.trim()) ? answers.email.trim() : null;

    return Object.assign(
      {
        session_id: state.sessionId,
        email,
        answers,
        history: clone(state.history) || [],
        recommended: clone(state.recommended) || [],
        ai_response: state.aiResponse || null,
        updated_at: new Date().toISOString(),
      },
      extra || {}
    );
  };

  const sendPayload = async (payload) => {
    try {
      const headers = { 'Content-Type': 'application/json' };
      if (config.apiKey) headers['x-quiz-key'] = config.apiKey;
      const res = await global.fetch(config.endpoint, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errText = await res.text();
        if (global.console && typeof global.console.warn === 'function') {
          global.console.warn('[SuiQuizLogger] Kayit basarisiz:', res.status, errText);
        }
      }
    } catch (err) {
      if (global.console && typeof global.console.warn === 'function') {
        global.console.warn('[SuiQuizLogger] Istek hatasi:', err);
      }
    }
  };

  const flush = (forcedPayload) => {
    if (!state.sessionId) return;
    const payload = forcedPayload || state.pendingPayload || buildPayload();
    state.pendingPayload = null;
    if (!payload) return;

    if (state.inFlight) {
      state.pendingPayload = payload;
      return;
    }

    state.inFlight = true;
    sendPayload(payload).finally(() => {
      state.inFlight = false;
      if (state.pendingPayload) {
        const nextPayload = state.pendingPayload;
        state.pendingPayload = null;
        flush(nextPayload);
      }
    });
  };

  const scheduleFlush = () => {
    if (state.flushTimer) return;
    state.flushTimer = global.setTimeout(() => {
      state.flushTimer = null;
      flush();
    }, 600);
  };

  global.SuiQuizLogger = {
    initSession(sessionId) {
      if (!sessionId || state.sessionId === sessionId) return;
      state.sessionId = sessionId;
      const now = new Date().toISOString();
      flush(
        buildPayload({
          created_at: now,
        })
      );
    },
    syncProgress(progress = {}) {
      if (progress.answers) state.answers = clone(progress.answers);
      if (progress.history) state.history = clone(progress.history);
      scheduleFlush();
    },
    recordRecommended(data = {}) {
      if (data.recommended) state.recommended = clone(data.recommended);
      if (Object.prototype.hasOwnProperty.call(data, 'aiResponse')) {
        state.aiResponse = data.aiResponse;
      }
      scheduleFlush();
    },
    markCompleted(extra = {}) {
      const payload = buildPayload(
        Object.assign(
          {
            completed_at: new Date().toISOString(),
          },
          extra || {}
        )
      );
      flush(payload);
    },
  };
})(window);
